import React, { useState, useRef, useEffect } from "react";
import { Document, Page } from "react-pdf";

const PDFViewer = ({ file }) => {
    const [numPages, setNumPages] = useState(null);
    const [scale, setScale] = useState(1);
    const containerRef = useRef(null);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const updateScale = () => {
        const containerWidth = containerRef.current
            ? containerRef.current.clientWidth
            : 0;
        const desiredWidth = 800; // Adjust this to match the PDF's original width
        const newScale = containerWidth / desiredWidth;
        setScale(Math.min(newScale, 1.5)); // Maximum scale limit
    };

    useEffect(() => {
        window.addEventListener("resize", updateScale);
        updateScale();
        return () => window.removeEventListener("resize", updateScale);
    }, []);

    return (
        <div className="pdf-canvas-container" ref={containerRef}>
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.from(new Array(numPages), (el, index) => (
                    <React.Fragment key={`page_${index + 1}`}>
                        <div className="pdf-page-wrapper">
                            <Page
                                pageNumber={index + 1}
                                scale={scale}
                                renderMode="canvas"
                                renderTextLayer={false}
                            />
                        </div>
                        <div className="page-number">
                            Page {index + 1} of {numPages}
                        </div>
                    </React.Fragment>
                ))}
            </Document>
        </div>
    );
};

export default PDFViewer;
